export enum MoreScreenNames {
  MAIN = 'more',
  MORE = 'more-menu',
}
